angular.module('natura').provider(
  "pggEditProvider",
  [function () {
    /*************************************************************************
     * CONFIG
     ************************************************************************/
    var config = {
      scope: null,
      userId: null,
      layer: new ol.layer.Vector({}),
      jsts: {},
      styles: {},
      dummyFeature: {},
      select: null,
      modify: null,
      snap: null,
      draw: null,
      holeDraw: null,
      selectAndModify: null,
      backup: null,
      isSketchValid: true,
      userCanEdit: null
    };
    this.$get = [
      "$http",
      "$log",
      "$uibModal",
      "pggConfigProvider",
      "pggJstsProvider",
      "pggStyleProvider",
      "pggAdatlapProvider",
      "pggEloirasProvider",
      "pggSearchProvider",
      function ($http, $log, $uibModal, pggConfigProvider, pggJstsProvider, pggStyleProvider, pggAdatlapProvider,
        pggEloirasProvider, pggSearchProvider) {
        /*******************************************************************
         * GETTERS AND SETTERS
         ******************************************************************/
        var _getConfig = function () {
          return config;
        };
        var _getUserId = function () {
          return config.userId;
        };
        var _setUserId = function (userId) {
          config.userId = userId;
        };
        var _getScope = function () {
          return config.scope;
        };
        var _setScope = function (scope) {
          config.scope = scope;
        };
        var _getEditLayer = function () {
          return config.layer;
        };
        var _setEditLayer = function (layer) {
          config.layer = layer;
        };
        var _getStyles = function () {
          return config.styles;
        };
        var _setStyles = function (styles) {
          config.styles = styles;
        };
        var _getJsts = function () {
          return config.jsts;
        };
        var _setJsts = function (jsts) {
          config.jsts = jsts;
        };
        var _getDraw = function () {
          return config.draw;
        };
        var _setDraw = function (draw) {
          config.draw = draw;
        };
        var _getSelect = function () {
          return config.select;
        };
        var _setSelect = function (select) {
          config.select = select;
        };
        var _getModify = function () {
          return config.modify;
        };
        var _setModify = function (modify) {
          config.modify = modify;
        };
        var _getSelectAndModify = function () {
          return config.selectAndModify;
        };
        var _setSelectAndModify = function (selectAndModify) {
          config.selectAndModify = selectAndModify;
        };
        var _getSnap = function () {
          return config.snap;
        };
        var _setSnap = function (snap) {
          config.snap = snap;
        };
        var _getHoleDraw = function () {
          return config.holeDraw;
        };
        var _setHoleDraw = function (holeDraw) {
          config.holeDraw = holeDraw;
        };
        var _getDummyFeature = function () {
          return config.dummyFeature;
        };
        var _setDummyFeature = function (dummyFeature) {
          config.dummyFeature = dummyFeature;
        };
        var _getBackup = function () {
          return config.backup;
        };
        var _setBackup = function (backup) {
          config.backup = backup;
        };
        var _getUserCanEdit = function () {
          return config.userCanEdit;
        };
        var _setUserCanEdit = function (userCanEdit) {
          config.userCanEdit = userCanEdit;
        };

        /*******************************************************************
         * FUNCTIONS
         ******************************************************************/
        var _styleByValidGeom = function (feature, isValid, errorStyle, okStyle) {
          if (isValid) {
            feature.setStyle(okStyle);
          } else {
            feature.setStyle(errorStyle);
          }
        };

        var _getGazdalkodasiTeruletByIdPromise = function (id) {
          var promise = $http.get(pggConfigProvider.getBaseUrl() + "/gis/gazdalkodasi-terulet/" + id, {
            headers: {
              'X-CSRF-TOKEN': pggConfigProvider.getCsrfToken()
            }
          }).then(function (response) {
            return response;
          });
          return promise;
        };

        var _postGazdalkodasiTeruletPromise = function (postData) {
          var promise = $http.post(pggConfigProvider.getBaseUrl() + "/gis/gazdalkodasi-terulet", postData, {
            headers: {
              'X-CSRF-TOKEN': pggConfigProvider.getCsrfToken()
            }
          }).then(function (response) {
            return response;
          });
          return promise;
        };

        var _getFeatureFromFeatureArrayById = function (featureArray, id) {
          for (var i = 0; i < featureArray.length; i++) {
            if (featureArray[i].getProperties().id == id) {
              return featureArray[i];
            }
          }
        };

        var _pushNewFeatureToSelection = function (feature, isValid) {
          _getScope().selectedElements = [];
          _getScope().selectedElements.push({});
          _getScope().selectedElements[0].feature = feature;
          _getScope().selectedElements[0].valid = isValid;
          _getScope().selectedElements[0].properties = feature.getProperties();
          _getScope().selectedElements[0].name = feature.getProperties().name;
          _getScope().selectedElements[0].datasheet = {};
        };

        var _reloadAffected = function (feature, affected, isNewFeature) {
          if (affected.length > 0) {
            var postData2 = {
              justTheseOnes: affected
            };
            // módosított elemeket újra le kell kérdezni a
            // frissített geometriával
            _postGazdalkodasiTeruletPromise(postData2).then(
              function (data2) {
                if (data2.data.errors === null) {
                  var source = config.layer.getSource();
                  var affectedFeatures = new ol.format.GeoJSON().readFeatures(data2.data.geojson);
                  var currExtent = _getScope().map.getView().calculateExtent(_getScope().map.getSize());
                  // befrissíteni azokat az elemeket,
                  // amik módosultak
                  source.forEachFeatureIntersectingExtent(currExtent, function (sourceFeat) {
                    var sourceFeatId = sourceFeat.getProperties().id;
                    var index = affected.indexOf(sourceFeatId);
                    if (index != -1) {
                      var affFeat = _getFeatureFromFeatureArrayById(affectedFeatures, sourceFeatId);
                      sourceFeat.setProperties(affFeat.getProperties());
                      sourceFeat.setGeometry(affFeat.getGeometry());
                      // módosítani a searchable opciót
                      pggSearchProvider.updateOptionForGazdalkodoiByFeature(sourceFeat);
                    }
                  });
                  if (isNewFeature) {
                    // a legutolsó affected elemet
                    // automatikusan
                    // hozzáadni, mert ez a frissen
                    // létrehozott
                    // geometria
                    var newFeatureId = affected[affected.length - 1];
                    for (var i = 0; i < affectedFeatures.length; i++) {
                      if (affectedFeatures[i].getProperties().id == newFeatureId) {
                        // ki kell törölni az új geometriát a
                        // source-ból, majd hozzáadni a frissen
                        // behívottat
                        source.removeFeature(feature);
                        source.addFeature(affectedFeatures[i]);
                        _setBackup(affectedFeatures[i].clone());
                        // stílus beállítása
                        var isValid = pggJstsProvider.isValidGeom(affectedFeatures[i]);
                        _styleByValidGeom(affectedFeatures[i], isValid, pggStyleProvider.getErrorStyleByFeature(affectedFeatures[i]),
                          pggStyleProvider.getSelectStyleByFeature(affectedFeatures[i]));
                        // feature hozzáadása a $scope
                        // kiválasztott elemeihez
                        _getSelect().getFeatures().push(affectedFeatures[i]);
                        _pushNewFeatureToSelection(affectedFeatures[i], isValid);
                        // új elem rajzolásánál ne vegye
                        // úgy, hogy módosítás történt a
                        // form-ban
                        _getScope().editForm.element_geometry.$dirty = false;
                        // select legyen az aktív, ne a draw
                        _getDraw().setActive(false);
                        _getSelectAndModify().setActive(true);
                      }
                    }
                  }
                } else {
                  $log.error("hiba történt az újbóli post geometria lekérdezésnél");
                  $log.error(data2);
                }
              });
            _updateReloadableWMS();
          }
        };

        /**
         * Nyomon követi a szerkesztést, és pirosra színezi az elemet, ha
         * nem érvényes a geometriája
         *
         * @params feature: a folyamatban lévő rajzolt elem
         * @params numMinVertices: minimum töréspont (általában 3)
         * @params isHoleDraw: az adott ellenőrzés hagyományos rajzolás vagy
         *         belső terület kivágás során kerül ellenőrzésre
         *
         */
        var _traceSketchErrors = function (feature, numMinVertices, isHoleDraw) {
          var targetCoords = feature.getGeometry().getCoordinates()[0];
          // legalább háromszög alakja legyen, és a negyedik
          // (folyamatban lévő) koordináta-pár ne legyen két
          // tizedesjegy pontossággal az utolsó pont közelében
          // (tényleg háromszög alakja legyen)
          if (targetCoords.length > numMinVertices
            && (parseFloat(targetCoords[numMinVertices - 1][0]).toFixed(2) != parseFloat(
              targetCoords[numMinVertices][0]).toFixed(2) && parseFloat(targetCoords[numMinVertices - 1][1])
                .toFixed(2) != parseFloat(targetCoords[numMinVertices][1]).toFixed(2))) {
            // a geometria ellenőrzéshez egy új
            // ol.geom.Polygon-t hozok majd létre, ahhoz össze
            // kell gyűjteni a koordinátákat
            var newCoords = [[]];
            angular.forEach(targetCoords, function (coords) {
              newCoords[0].push(coords);
            });
            // a legelső koordinátát a végére is beteszem, hogy
            // zárt poligon legyen (jsts különben elhasal)
            newCoords[0].push(targetCoords[0]);
            var newGeom = new ol.geom.Polygon(newCoords);
            var newFeat = new ol.Feature({
              geometry: newGeom
            });
            var isNewValid = pggJstsProvider.isValidGeom(newFeat);
            // a draw eszköz stílusát attól teszem függővé, hogy
            // valid vagy nem valid a geometria
            if (!isNewValid) {
              _getConfig().isSketchValid = false;
            } else {
              // belső gyűrű rajzolásnál ellenőrizni kell a kiválasztott
              // elemmel
              // való metszést is
              if (!isHoleDraw) {
                _getConfig().isSketchValid = true;
              } else {
                var outerRing = _getScope().selectedElements[0].feature;
                var touchesOrOverlaps = pggJstsProvider.isRingTouchesOrOverlapsOuter(newFeat, outerRing);
                if (touchesOrOverlaps) {
                  _getConfig().isSketchValid = false;
                } else {
                  _getConfig().isSketchValid = true;
                }
              }
            }
          }
        };

        _pushOptionToSearchables = function (feature, affected, name) {
          var option = pggSearchProvider.createOptionForGazdalkodoi(feature);
          option.value = name + " (gazdálkodói terület)";
          option.id = affected[0];
          pggSearchProvider.pushOptionToSearchables(option);
        };

        _saveNewFeatureWithName = function (feature, name) {
          var properties = {
            forced: _getScope().draw.forced.value,
            name: name
          };
          var geojson = pggJstsProvider.geojsonFromOLFeature(feature, properties);
          var postData = {
            geojson: geojson
          };
          // elküldi az újonnan berajzolt elemet feltöltésre
          _postGazdalkodasiTeruletPromise(postData).then(function (data) {
            // megnézni, van-e hiba, és van-e affected
            // attribútum
            if (data.data.errors === null && data.data.hasOwnProperty("affected")) {
              // módosított elemek kezelése
              var affected = data.data.affected;
              _reloadAffected(feature, affected, true);
              _getScope().alerts.push({
                type: 'success',
                msg: 'A gazdálkodói terület rögzítése sikerült.'
              });
              _pushOptionToSearchables(feature, affected, name);
            } else {
              $log.error("hiba történt a post geometria lekérdezésnél");
              $log.error(data);
            }
          });
        };

        _openBaseInfoModal = function (size, feature) {
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'assets/terkep/app/modal/baseInfoModal.html',
            controller: 'PggBaseInfoModalController',
            size: size,
            backdrop: 'static',
            keyboard: false,
            resolve: {}
          });
          modalInstance.result.then(function (name) {
            _saveNewFeatureWithName(feature, name);

          }, function () {
            _getEditLayer().getSource().removeFeature(feature);
          });
        };

        /**
         * Draw interakció létrehozása
         *
         * @params geometryType: geometria típus ('MultiPolygon')
         */
        var _createDraw = function (geometryType) {
          var draw = {
            init: function () {
              _getScope().map.addInteraction(this.draw);
              this.setEvents(this.draw);
            },
            setEvents: function (mydraw) {
              this.draw.on("drawstart", function (e) {
                _removeInvalidSketches();
                // állítsa be a draw stílusát alapértelmezettre (vegye úgy,
                // hogy
                // érvényes volt a legutóbbi geometria)
                _getConfig().isSketchValid = true;
                // az elem rajzolása közben ellenőrizze a validitást
                e.feature.on('change', function (e2) {
                  _traceSketchErrors(e2.target, 3, false);
                });
              });
              this.draw.on("drawend", function (e) {
                // vegye úgy, hogy érvényes volt a legutóbbi geometria
                _getConfig().isSketchValid = true;
                var feature = e.feature;
                var isValid = pggJstsProvider.isValidGeom(feature);
                _styleByValidGeom(feature, isValid, pggStyleProvider.getErrorStyleByFeature(feature), pggStyleProvider.getDefaultStyleByFeature(feature));
                if (isValid) {
                  // el kell nevezni a területet
                  _openBaseInfoModal('sm', feature);
                } else {
                  _getScope().$apply(function () {
                    _getScope().alerts.push({
                      type: 'danger',
                      msg: 'Hibás geometria! A rajz nem kerül elmentésre, kérjük rajzoljon új elemet!'
                    });
                  });
                }
              });
            },
            draw: new ol.interaction.Draw({
              source: _getEditLayer().getSource(),
              type: geometryType,
              style: _drawStyleFunction
            }),
            getActive: function () {
              return this.draw.getActive();
            },
            setActive: function (active) {
              // kitörli az érvénytelen geometriájú sketch-eket
              _removeInvalidSketches();
              this.draw.setActive(active);
            }
          };
          draw.init();
          _setDraw(draw);
        };

        /**
         * Kitörlni a korábban benne hagyott, hibás geometriájú sketch-eket,
         * amiket arról lehet felismerni, hogy nincs pl. "created_at"
         * attribútumuk
         */
        var _removeInvalidSketches = function () {
          angular.forEach(_getEditLayer().getSource().getFeatures(), function (feat) {
            if (!feat.getProperties().hasOwnProperty("created_at")) {
              _getEditLayer().getSource().removeFeature(feat);
            }
          });
        };

        /**
         * Rajzoló stílus (dinamikus, ha a rajzolt sketch geometriája
         * invalid, akkor pirosítsa ki)
         *
         * @param feature:
         *          az éppen rajzolt elem (event target)
         */
        var _drawStyleFunction = function (feature) {
          switch (feature.getGeometry().getType()) {
            case "Point":
              return [new ol.style.Style({
                image: new ol.style.Circle({
                  radius: 3 * 2,
                  fill: new ol.style.Fill({
                    color: _getConfig().isSketchValid ? "rgba(0, 153, 255, 1)" : "rgba(255, 0, 0, 1)"
                  }),
                  stroke: new ol.style.Stroke({
                    color: "rgba(255, 255, 255, 1)",
                    width: 1
                  })
                }),
                zIndex: Infinity
              })];
            case "LineString":
              return [new ol.style.Style({
                stroke: new ol.style.Stroke({
                  color: "rgba(255, 255, 255, 1)",
                  width: 3
                })
              }), new ol.style.Style({
                stroke: new ol.style.Stroke({
                  color: _getConfig().isSketchValid ? "rgba(0, 153, 255, 1)" : "rgba(255, 0, 0, 1)",
                  width: 3
                })
              })];
            case "Polygon":
              return [new ol.style.Style({
                fill: new ol.style.Fill({
                  color: _getConfig().isSketchValid ? [0, 153, 255, 0.5] : "rgba(255, 0, 0, 0.5)"
                })
              })];
            default:
              return null;
          }
        };

        /**
         * Belső gyűrű rajzoló létrehozása
         *
         * @param vertsCounter:
         *          töréspont számoló, 0-ról indul
         */
        // see http://jsfiddle.net/p_tsagkis/d53m34ne/
        var _createHoleDraw = function (vertsCounter) {
          _getConfig().isSketchValid = true;
          var myHoleDraw = {
            init: function () {
              var selFeat = _getSelect().getFeatures().getArray()[0];
              var geomTypeSelected = selFeat.getGeometry().getType();
              if (geomTypeSelected !== 'MultiPolygon') {
                // alert("Only MultiPolygon
                // geometry selections. Not " +
                // geomTypeSelected);
                // return;
              } else {
                selFeat.setGeometry(selFeat.getGeometry().getPolygons()[0]);
              }
              var holeDraw = this.holeDraw;
              _getScope().map.addInteraction(holeDraw);
              this.setEvents(holeDraw);
            },
            holeDraw: new ol.interaction.Draw({
              source: new ol.source.Vector(),
              type: 'Polygon',
              style: _drawStyleFunction
            }),
            setEvents: function (holeDraw) {
              this.holeDraw.on("drawstart", function (e) {
                _removeInvalidSketches();
                _getConfig().isSketchValid = true;
                _getSelect().setActive(false);
                _getModify().setActive(false);
                var feature = e.feature;
                var ringAdded = false;
                feature.on('change', function (e) {
                  _traceSketchErrors(e.target, 2, true);
                });
              });
              this.holeDraw.on("drawend", function (e) {
                if (_getConfig().isSketchValid) {
                  var selFeat = _getScope().selectedElements[0].feature;
                  var feature = e.feature;
                  // összeállítom az új koordinátákat a kiválaszott
                  // geometria
                  // eddigi gyűrűiből, utána meg hozzáadom az új elem
                  // koordinátáit is
                  var newCoordinates = [];
                  angular.forEach(selFeat.getGeometry().getCoordinates(), function (ring) {
                    newCoordinates.push(ring);
                  });
                  newCoordinates.push(feature.getGeometry().getCoordinates()[0]);
                  var newGeom = new ol.geom.Polygon(newCoordinates);
                  // kiválasztott geometria felülírása
                  selFeat.setGeometry(newGeom);
                } else {
                  _getScope().$apply(function () {
                    _getScope().alerts.push({
                      type: 'danger',
                      msg: 'Hibás geometria! A rajz nem kerül elmentésre, kérjük rajzoljon új elemet!'
                    });
                  });
                }
                holeDraw.setActive(false);
                _getSelect().setActive(true);
                _getModify().setActive(true);
                _getScope().map.removeInteraction(holeDraw);
                // állítsa vissza a
                // gyűrűrajzolót false-ra
                _getScope().$apply(function () {
                  _getScope().innerRing.checked = false;
                  _getScope().editForm.element_geometry.$dirty = true;
                });
              });
            },
            disable: function () {
              _getScope().map.removeInteraction(this.holeDraw);
            }
          };
          myHoleDraw.init();
          _setHoleDraw(myHoleDraw);
        };

        /**
         * Modify interakció létrehozása. Ez egyben egy
         * ol.interaction.Select és egy ol.interaction.Modify elemet is
         * létrehoz
         */
        var _createModify = function () {
          var holeDraw = null;
          var vertsCounter;
          var selectAndModify = {
            init: function () {
              this.select = new ol.interaction.Select({
                style: pggStyleProvider.getSelectStyleByFeature,
                // ne legyen lehetőség multiple select-re a shift
                // lenyomásával
                toggleCondition: ol.events.condition.never
              });
              _getScope().map.addInteraction(this.select);
              _setSelect(this.select);
              this.modify = new ol.interaction.Modify({
                features: this.select.getFeatures()
              });
              _getScope().map.addInteraction(this.modify);
              _setModify(this.modify);
              this.setEvents();
            },
            setEvents: function () {
              var selectedFeatures = this.select.getFeatures();
              this.select.on("select", function (e) {
                if (e.selected.length > 0) {
                  // fontos, hogy előbb a deselected-en menjen végig
                  angular.forEach(e.deselected, function (feature) {
                    if (_getScope().selectedElements.length > 0 && _getScope().selectedElements[0].hasOwnProperty("name")) {
                      var name = _getScope().selectedElements[0].name;
                      var isValid = pggJstsProvider.isValidGeom(feature);
                      _styleByValidGeom(feature, isValid, pggStyleProvider.getErrorStyleByFeature(feature), pggStyleProvider.getDefaultStyleByFeature(feature));
                      // Csak akkor legyen _cancel, ha volt változtatás a
                      // geometriában vagy az attribútumokban (az editForm
                      // $dirty)
                      if (_getScope().editForm.element_name.$dirty || _getScope().editForm.element_geometry.$dirty) {
                        var modalInstance = $uibModal.open({
                          animation: true,
                          templateUrl: 'assets/terkep/app/modal/cancelModificationsModal.html',
                          controller: 'PggCancelModificationsModalController',
                          size: '',
                          backdrop: 'static',
                          resolve: {
                            feature: function () {
                              return feature;
                            },
                            userCanEdit: function () {
                              return _getUserCanEdit();
                            }
                          }
                        });
                        modalInstance.result.then(function () {
                          _update(feature, name, false);
                        }, function () {
                          _cancel(feature, false, true);
                        });
                      }
                    }
                  });
                  angular.forEach(e.selected,
                    function (feature) {
                      _setBackup(feature.clone());
                      var isValid = pggJstsProvider.isValidGeom(feature);
                      _styleByValidGeom(feature, isValid, pggStyleProvider.getErrorSelectedStyleByFeature(feature),
                        pggStyleProvider.getSelectStyleByFeature(feature));
                      pggAdatlapProvider.getDatasheetsByFeatureIdPromise(feature.getProperties().id).then(
                        function (data) {
                          _getScope().selectedElements = [];
                          _getScope().selectedElements.push({});
                          _getScope().selectedElements[0].feature = feature;
                          _getScope().selectedElements[0].valid = isValid;
                          _getScope().selectedElements[0].properties = feature.getProperties();
                          _getScope().selectedElements[0].name = feature.getProperties().name;
                          _getScope().selectedElements[0].datasheets = data.data.datasheets;
                        });
                    });
                } else {
                  angular.forEach(e.deselected, function (feature) {
                    var name = _getScope().selectedElements[0].name;
                    var isValid = pggJstsProvider.isValidGeom(feature);
                    // Csak akkor legyen _cancel, ha volt változtatás a
                    // geometriában vagy az attribútumokban (az editForm
                    // $dirty)
                    if (_getScope().editForm.element_name.$dirty || _getScope().editForm.element_geometry.$dirty) {
                      _styleByValidGeom(feature, isValid, pggStyleProvider.getErrorSelectedStyleByFeature(feature),
                        pggStyleProvider.getSelectStyleByFeature(feature));
                      var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'assets/terkep/app/modal/cancelModificationsModal.html',
                        controller: 'PggCancelModificationsModalController',
                        size: '',
                        backdrop: 'static',
                        resolve: {
                          feature: function () {
                            return feature;
                          },
                          userCanEdit: function () {
                            return _getUserCanEdit();
                          }
                        }
                      });
                      modalInstance.result.then(function () {
                        _update(feature, name, false);
                      }, function () {
                        _cancel(feature, false, true);
                      });
                    } else {
                      _styleByValidGeom(feature, isValid, pggStyleProvider.getErrorStyleByFeature(feature),
                        pggStyleProvider.getDefaultStyleByFeature(feature));
                    }
                  });
                  _getScope().$apply(function () {
                    _getScope().selectedElements = [];
                  });
                }
              });
              this.modify.on("modifyend", function (e) {
                var feature = e.features.getArray()[0];
                var isValid = pggJstsProvider.isValidGeom(feature);
                _styleByValidGeom(feature, isValid, pggStyleProvider.getErrorSelectedStyleByFeature(feature),
                  pggStyleProvider.getSelectStyleByFeature(feature));
                _getScope().$apply(function () {
                  _getScope().selectedElements[0].valid = isValid;
                  _getScope().editForm.element_geometry.$dirty = true;
                });
              });
            },
            getActive: function () {
              return (this.modify.getActive() && this.select.getActive());
            },
            setActive: function (active) {
              this.select.setActive(active);
              this.modify.setActive(active);
            },
            setHoleDrawActive: function (active) {
              var holeDraw;
              if (active && _getSelect().getFeatures().getArray().length > 0) {
                var vertsCounter = 0;
                holeDraw = _createHoleDraw(vertsCounter);
              } else {
                _getSelect().setActive(true);
                _getModify().setActive(true);
              }
            },
            clearFeatures: function () {
              angular.forEach(_getSelect().getFeatures().getArray(), function (feature) {
                feature.setStyle(pggStyleProvider.getDefaultStyleByFeature(feature));
              });
              this.select.getFeatures().clear();
              _getScope().selectedElements = [];
            },
            removeFeatures: function () {
              angular.forEach(_getSelect().getFeatures().getArray(), function (feature) {
                _getEditLayer().getSource().removeFeature(feature);
              });
              _getSelect().getFeatures().clear();
            }
          };
          selectAndModify.init();
          _setSelectAndModify(selectAndModify);
        };

        /**
         * Snap interakció létrehozása
         */
        var _createSnap = function () {
          var snap = {
            init: function () {
              this.snap = new ol.interaction.Snap({
                source: _getEditLayer().getSource()
              });
              _getScope().map.addInteraction(this.snap);
            },
            getActive: function () {
              return this.snap.getActive();
            },
            setActive: function (active) {
              this.snap.setActive(active);
            }
          };
          snap.init();
          _setSnap(snap);
        };

        /**
         * Azon TileWMS rétegek újrarajzolása, ahol a "reloadOnNew"
         * paraméter true, ilyen pl. a "clipped" réteg
         */
        var _updateReloadableWMS = function () {
          for (var l = 0; l < _getScope().map.getLayers().getArray().length; l++) {
            var lyr = _getScope().map.getLayers().getArray()[l];
            if (lyr instanceof ol.layer.Tile && lyr.get("reloadable")) {
              lyr.getSource().updateParams({
                "time": Date.now()
              });
            }
          }
        };

        /**
         * Helyreállítja egy adott feature eredeti állapotát Három esetben
         * lehetséges: 1. "Mégsem"-re kattintás 2. egyik elemről a másikra
         * (közben lehet, hogy változtatott az elemen) 3. kijelölés
         * megszüntetése
         *
         * @param feature:
         *          adott ol.Feature objektum
         * @param clearSelection:
         *          szüntesse-e meg a kijelölést (Mégsem-nél igen), vagy ne
         *          (másik elem kijelölése vagy kijelölés megszüntetése)
         */
        var _cancel = function (feature, keepStyleSelected, showFeedback) {
          // ha az előírásokban volt változás, akkor vissza kell állítani az
          // eredeti (adatbázisból jövő) értéket
          if (_getScope().selectedElements.length > 0) {
            var modifiedEloirasok = pggEloirasProvider.getModifiedEloirasok(_getScope().editForm.eloiras_table_dirty,
              _getScope().selectedElements[0].eloirasok);
            if (modifiedEloirasok.declarations.length > 0) {
              angular.forEach(modifiedEloirasok.declarations, function (eloiras) {
                // legördülő menü opciói
                var options = pggEloirasProvider.getOptions();
                for (var i = 0; i < options.length; i++) {
                  // az eredeti értékkel veti össze, nem a selected értékével
                  if (options[i].id == eloiras.obj.declaration_id) {
                    // a selected értékét átállítja az eredeti legördőlőre, a
                    // többit az angular majd elvégzi
                    eloiras.obj.selected = options[i];
                    break;
                  }
                }
              });
              _getScope().editForm.eloiras_table_dirty = false;
            }
          }
          // 1. adott id-jű elem lekérdezése
          _getGazdalkodasiTeruletByIdPromise(feature.getProperties().id).then(function (data) {
            if (data.status == 200 && data.statusText == "OK" && data.data.errors === null) {
              // 2a. beszerzett elemből ol.Feature előállítása, elvileg
              // pontosan
              // 1 db geometria lehet benne (akkor is, ha van belső gyűrűje)
              var feature = new ol.format.GeoJSON().readFeatures(data.data.geojson)[0];
              // 2b. módosított (aktuálisan kijelölt) elem lecserélése a
              // régire
              var source = _getEditLayer().getSource();
              for (var i = 0; i < source.getFeatures().length; i++) {
                var featToOverwrite = source.getFeatures()[i];
                if (featToOverwrite.getProperties().id == feature.getProperties().id) {
                  featToOverwrite.setGeometry(feature.getGeometry());
                  featToOverwrite.setProperties(feature.getProperties());
                  if (_getScope().selectedElements.length > 0) {
                    _getScope().selectedElements[0].name = _getBackup().getProperties().name;
                    _getScope().editForm.element_name.$dirty = false;
                    _getScope().editForm.element_geometry.$dirty = false;
                  }
                  if (keepStyleSelected) {
                    featToOverwrite.setStyle(pggStyleProvider.getSelectStyleByFeature(featToOverwrite));
                  } else {
                    featToOverwrite.setStyle(pggStyleProvider.getDefaultStyleByFeature(featToOverwrite));
                  }
                  if (showFeedback) {
                    _getScope().alerts.push({
                      type: 'success',
                      msg: 'A módosítások elvetése sikerült.'
                    });
                  }
                  break;
                }
              }
            } else {
              $log.error("hiba történt a cancel során");
              $log.error(data);
            }
          });
        };

        /**
         * Felülírja a kijelölt elemeket abban az esetben, ha történt
         * módosítás (attribútum vagy geometria)
         *
         * @param selectedElements:
         *          kijelölt elemek tömbje
         */
        var _update = function (feature, name, keepStyleSelected) {
          feature.set("name", name);
          var id = feature.getProperties().id;
          var properties = {
            forced: _getScope().draw.forced.value,
            name: (name === null || name.length === 0) ? null : name,
            id: id
          };
          var geojson = pggJstsProvider.geojsonFromOLFeature(feature, properties);
          var postData = {
            geojson: geojson
          };
          var promise = $http.put(pggConfigProvider.getBaseUrl() + "/gis/gazdalkodasi-terulet", postData).then(
            function (response) {
              return response;
            });
          promise.then(function (data) {
            if (data.status == 200 && data.statusText == "OK" && data.data.hasOwnProperty("affected")
              && data.data.affected.length > 0) {
              // frissíti a módosított elemeket
              _reloadAffected(feature, data.data.affected, false);

              _getGazdalkodasiTeruletByIdPromise(id).then(function (ufdata) {
                var uf_updated_at = ufdata.data.geojson.features[0].properties.updated_at;
                feature.set("updated_at", uf_updated_at);
                if (_getScope().selectedElements.length > 0) {
                  _getScope().selectedElements[0].properties.updated_at = uf_updated_at;
                  _getScope().editForm.element_name.$dirty = false;
                  _getScope().editForm.element_geometry.$dirty = false;
                  // az előírásokat is be kell frissíteni
                  _getScope().selectedElements[0].eloirasok = null;
                  _getScope().hideHoverLayer();
                  _getScope().alerts.push({
                    type: 'success',
                    msg: 'Az elem módosítása sikerült.'
                  });
                  _getScope().getEloirasok(true);
                }
                if (keepStyleSelected) {
                  feature.setStyle(pggStyleProvider.getSelectStyleByFeature(feature));
                } else {
                  feature.setStyle(pggStyleProvider.getDefaultStyleByFeature(feature));
                }
                // frissíti a wms rétegeket
                _updateReloadableWMS();
                // frissíti a keresési opciót
                pggSearchProvider.updateOptionForGazdalkodoiByFeature(feature);
              });
            } else {
              $log.error("Valami baj történt az elem update során");
              $log.error(data);
            }
          });
        };

        /**
         * Eltávolítja a kijelölt elemeket.
         *
         * @param selectedElements:
         *          kijelölt elemek tömbje
         */
        var _remove = function (selectedElements) {
          angular.forEach(selectedElements, function (element) {
            var feature;
            // meg kell különböztetni aszerint, hogy új elem rajzolásánál az
            // elvetésről (adatlap ki nem töltése) vagy meglévő elem törléséről
            // van
            // szó. Új elem rajzolásánál ol.Feature van, amúgy a
            // selectedElements-ből kell kiszedni a feture-ket
            if (element instanceof ol.Feature) {
              feature = element;
              config.layer.getSource().removeFeature(feature);
            } else {
              feature = element.feature;
              _getScope().interactions.modify.removeFeatures();
              _getScope().selectedElements = [];
            }
            var id = feature.getProperties().id;
            var promise = $http['delete'](pggConfigProvider.getBaseUrl() + "/gis/gazdalkodasi-terulet/" + id).then(
              function (response) {
                return response;
              });
            promise.then(function (data) {
              // kitörölni a searchable opciók közül is
              pggSearchProvider.deleteOptionForGazdalkodoiById(id);
              _updateReloadableWMS();
            });
          });
        };

        /***********************************************************************
         * RETURNS
         **********************************************************************/
        return {
          getScope: _getScope,
          setScope: _setScope,
          getUserId: _getUserId,
          setUserId: _setUserId,
          getUserCanEdit: _getUserCanEdit,
          setUserCanEdit: _setUserCanEdit,
          setDummyFeature: _setDummyFeature,
          setEditLayer: _setEditLayer,
          setStyles: _setStyles,
          setJsts: _setJsts,
          getDraw: _getDraw,
          getSelectAndModify: _getSelectAndModify,
          getSnap: _getSnap,
          createDraw: _createDraw,
          createModify: _createModify,
          createSnap: _createSnap,
          createHoleDraw: _createHoleDraw,
          getBackup: _getBackup,
          setBackup: _setBackup,
          updateReloadableWMS: _updateReloadableWMS,
          cancel: _cancel,
          remove: _remove,
          update: _update
        };
      }];

  }]);
